import { Collection, Map } from "ol";
import BaseLayer from "ol/layer/Base";
import LayerGroup from "ol/layer/Group";

export function flattenMapLayers(map: Map): BaseLayer[] {
  const layers: BaseLayer[] = [];

  const layersToArray = (collection: Collection<BaseLayer> | LayerGroup) => {
    let lay: Collection<BaseLayer>;
    if (collection instanceof LayerGroup) {
      lay = collection.getLayers();
    } else {
      lay = collection;
    }
    lay.forEach((l) => {
      if (l instanceof LayerGroup) {
        layersToArray(l);
      } else {
        layers.push(l);
      }
    });
  };
  layersToArray(map.getLayers());

  return layers;
}
